export default __webpack_public_path__ + "static/media/power_bw.bf9e31ac.png";